<template>
  <div
    class="view-file pdf"
    v-if="seen"
    @click="close_box"
    @contextmenu="notallowed"
  >
    <div v-if="downloadRight && !styleHelper.isMobile" class="img">
      <iframe :src="path" width="100%" height="100%"></iframe>
    </div>
    <div
      v-if="!downloadRight || styleHelper.isMobile"
      ref="view-only"
      class="view-only"
    >
      <div class="info">
        <div class="d-flex justify-content-between align-items-center p-2">
          <span>
            <input v-model="navPage" @keyup="scroll()" class="nav-input" /> of
            {{ pageCount }}
          </span>
          <span v-if="!styleHelper.isMobile">
            <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M12,4.5C17,4.5 21.27,7.61 23,12C21.27,16.39 17,19.5 12,19.5C7,19.5 2.73,16.39 1,12C2.73,7.61 7,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C15.76,17.5 19.17,15.36 20.82,12C19.17,8.64 15.76,6.5 12,6.5C8.24,6.5 4.83,8.64 3.18,12Z"
              />
            </svg>
            view only
          </span>
          <button
            v-if="printRight"
            @click="printPDF"
            class="btn btn-light print-btn"
          >
            <span>
              <svg style="width: 24px; height: 24x" viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M18,3H6V7H18M19,12A1,1 0 0,1 18,11A1,1 0 0,1 19,10A1,1 0 0,1 20,11A1,1 0 0,1 19,12M16,19H8V14H16M19,8H5A3,3 0 0,0 2,11V17H6V21H18V17H22V11A3,3 0 0,0 19,8Z"
                />
              </svg>
            </span>
          </button>
        </div>
        <div
          class="pdf-loader p-1"
          v-bind:style="[
            hideLoader === true ? { display: 'none' } : { display: 'block' },
          ]"
          ref="loaderEl"
        ></div>
      </div>
      <div ref="pages">
        <div v-for="i in numPages" :key="i" :ref="`page${i}`" :data="i">
          <pdf
            :src="path"
            :page="i"
            @num-pages="pageCount = $event"
            @page-loaded="setCurrentPage($event, $refs['loaderEl'], i)"
            @loaded="docloaded(i, numPages)"
            class="m-4"
          ></pdf>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@media only print {
  .view-file {
    display: none;
  }
}
.pdf-loader {
  background-color: #1e6abb;
  width: 0%;
}
.print-btn {
  color: white;
  background-color: #323639;
}
.nav-input {
  color: white;
  background-color: #323639;
  text-align: center;
  border: 1px solid #525659;
  width: 2rem;
}
.nav-input:focus {
  border: 2px solid #525659;
}
.view-only {
  background-color: #525659;
  width: 80%;
  height: 100vh;
  overflow: auto;
}
.view-only .info {
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 0;
  /* height: 3.5rem; */
  width: 100%;
  z-index: 1;
  background-color: #323639;
  color: white;
}
</style>

<script>
import { setTimeout } from "timers";
import config from "@/services/config";
import cookies from "@/services/cookies";
import pdf from "vue-pdf";
import printJS from "print-js";
import { styleHelper } from "../utils";

export default {
  components: {
    pdf,
  },
  data() {
    return {
      name: "",
      seen: false,
      index: "",
      id: "",
      path: "",
      originalPath: "",
      downloadRight: false,
      printRight: false,
      numPages: 0,
      observer: null,
      currentPage: 0,
      pageCount: 0,
      pageRef: null,
      navPage: 1,
      loaderEl: null,
      hideLoader: true,
    };
  },
  methods: {
    styleHelper,
    setCurrentPage(e, loaderEl, i) {
      if (loaderEl && this.numPages) {
        const result = (i * 100) / this.numPages;
        if (result == 100) {
          this.hideLoader = true;
        }
        loaderEl.style.width = `${result}%`;
      }
      this.currentPage = e;
    },
    scroll() {
      // setTimeout(() => {
      const el = this.$refs[`page${this.navPage}`];
      el[0].scrollIntoView({ block: "start", inline: "nearest" });
      // }, 2000)
    },
    loaderBar() {},
    docloaded(i, numPages, loaderEl) {
      if (i == numPages) {
        this.observerIntersection(this.$refs["pages"].children);
      }
    },
    observerIntersection(pages) {
      const options = {
        root: this.$refs["view-only"],
        rootMargin: "0px",
        threshold: 0.75,
      };
      const observer = new IntersectionObserver(this.handleIntersect, options);
      [...pages].forEach((page) => observer.observe(page));
    },
    handleIntersect(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.navPage = entry.target.getAttribute("data");
        }
      });
    },
    printPDF() {
      printJS(this.originalPath, "pdf");
    },
    logincall() {
      this.$parent.logincall();
    },
    load(id, rights) {
      if (rights === null) {
        this.path = "";
        this.seen = true;
        this.id = id;

        let that = this;

        this.downloadRight = true;
        this.printRight = true;

        let data = {
          token: cookies.getCookie("token"),
          id: this.id,
        };

        this.$socket.emit("loadpdf", data, function (data) {
          if (data.data === true) {
            that.path =
              process.env.VUE_APP_NODE_ENV === "development"
                ? process.env.VUE_APP_HTTP +
                  "://" +
                  config.origin +
                  ":" +
                  process.env.VUE_APP_PORT +
                  "/pdf/" +
                  that.id +
                  "/" +
                  cookies.getCookie("token")
                : process.env.VUE_APP_HTTP +
                  "://" +
                  config.origin +
                  "/pdf/" +
                  that.id +
                  "/" +
                  cookies.getCookie("token");
          }

          if (data.data === false) {
            that.seen = false;
            that.logincall();
            that.$router.push('/login')
          }
        });
      } else {
        if (rights.db === "group" || rights.db === "sharedwithme") {
          this.downloadRight = rights.download_right || rights.download;
          this.printRight = rights.print_right || rights.print;
        } else {
          this.downloadRight = true;
        }
        this.path = "";
        this.seen = true;
        this.id = id;

        let that = this;

        let data = {
          token: cookies.getCookie("token"),
          id: this.id,
        };

        this.$socket.emit("loadpdf", data, function (data) {
          if (data.data === true) {
            that.path =
              process.env.VUE_APP_NODE_ENV === "development"
                ? process.env.VUE_APP_HTTP +
                  "://" +
                  config.origin +
                  ":" +
                  process.env.VUE_APP_PORT +
                  "/pdf/" +
                  that.id +
                  "/" +
                  cookies.getCookie("token")
                : process.env.VUE_APP_HTTP +
                  "://" +
                  config.origin +
                  "/pdf/" +
                  that.id +
                  "/" +
                  cookies.getCookie("token");
          }

          that.originalPath = that.path;

          if (!that.downloadRight || that.styleHelper.isMobile) {
            that.hideLoader = false;
            that.path = pdf.createLoadingTask(that.path);
            that.path.promise.then((pdf) => {
              that.numPages = pdf.numPages;
            });
          }

          if (data.data === false) {
            that.seen = false;
            that.logincall();
            that.$router.push('/login')
          }
        });
      }
    },
    notallowed(e) {
      e.preventDefault();
    },
    close_box(evt) {
      if (
        evt.target.className === "view-file pdf" ||
        evt.target.className.baseVal === "close"
      ) {
        this.seen = false;

        let data = {
          token: cookies.getCookie("token"),
          fileid: this.id,
        };
        this.$socket.emit("deleteblock", data);
      }
    },
  },
};
</script>
